export default __webpack_public_path__ + "static/media/q10_step3.2d83d469.png";